module.exports = __webpack_public_path__ + "static/media/mic_off.b66db9af.svg";